import React from 'react';
import cn from 'classnames';
import { Icon as BaseIcon, IconProps as BaseIconProps } from '@economic/gaudi';

type State = 'default' | 'success' | 'error' | 'warning' | 'information';

interface Props extends BaseIconProps {
    badge?: State;
}

const variants: { [key in State]: string } = {
    default: 'bg-grey text-black',
    success: 'bg-green text-white',
    warning: 'bg-yellow text-white',
    error: 'bg-red text-white',
    information: 'bg-blue text-white',
};

export default function Icon({ name, badge = 'default', ...props }: Props) {
    return <BaseIcon {...props} name={name} className={cn('rounded-full', variants[badge])} />;
}
